import NetworkManager from '../NetworkManager';

export default function Footer() {

  return (
    <footer id="Footer" className="bg-img-hero-footer bg-dark py-2 customBgColor site-footer">
      <div className="container">
        <div className="row justify-content-sm-between align-items-center">
          <div>
            <div className="d-flex align-items-center">
              <span className="h6 text-black mb-0">Powered by MovaChain</span>
            </div>
          </div>
          <div>
            <div className="d-flex justify-content-sm-end align-items-center">
              <NetworkManager />
            </div>
          </div>
          <div>
            <span className="mb-0 text-black">
              Mova Foundation © {new Date().getFullYear()}
            </span>
          </div>
          
        </div>
        {/* <div className="row justify-content-between align-items-center font-size-1 mt-2">
          
          <div className="col-md-6 text-md-right">
            <ul className="list-inline mb-0">
              <li className="list-inline-item">
                
              </li>
              <li className="list-inline-item">
                
              </li>
            </ul>
          </div>
        </div> */}
      </div>
    </footer>
  );
}
